var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{attrs:{"routeLeadsTo":_vm.routeLeadsTo,"routeLeadsToTitle":_vm.routeLeadsToTitle,"sidebarExpandedProp":_vm.sidebarExpandedProp,"bluredProp":_vm.bluredProp},on:{"expenseStatus":_vm.paymentStatus,"clearInputErrorsPayments":_vm.clearInputErrors,"clearOthersPayments":_vm.clearOthers,"checkAnyInput":_vm.checkAnyInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }